/*****
 * Created by Allan on 2021/11/05.
 * Contact 84880528@qq.com.
 * 用户登入
 * *****/
import { Base64 } from 'js-base64'
import getQueryVariable from '@/baseloan/service/getQueryVariable'
import Http from '@/baseloan/service/http/'
export default{
    state:{
        userInfo:JSON.parse(localStorage.getItem(Base64.decode(getQueryVariable('b')))) || {}, //H5用户登入信息
    },
    //Getter 接受 state 作为其第一个参数,可以接受其他 getter 作为第二个参数
    getters:{
        userInfo:state=>state.userInfo,
    },
    //state 作为第一个参数
    mutations:{
        setUserInfo(state,data){
            localStorage.setItem(Base64.decode(getQueryVariable('b')),JSON.stringify(data));
            state.userInfo=data;
        },
    },
    //Action 提交的是 mutation，而不是直接变更状态
    actions:{
        getUserInfo({commit},params){
            return new Promise((resolve,reject)=>{
                Http('/skip/v1/web/user/login',{method:'post',data:params,reqType:'json'}).then(res=>{
                    console.log('H5用户登入',res);
                    commit('setUserInfo',res.data)
                    resolve(res.data)
                }).catch((e) => {
                    reject(e)
                })
            })
        },
    },
}





// WEBPACK FOOTER //
// ./src/baseloan/store/module/user.js